import { useLocation, useNavigate } from 'react-router-dom';
import { GAEvent } from '~/utils';
import { GA } from '~/constants';
import { useUserStore } from '~/store';
import Menu from '../Menu/Menu';
import { navigationArr } from '../Navigation';
import * as S from './Bubble.styled';

export default function Bubble({ isOpen }: { isOpen: boolean }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (menuUrl: string) => location.pathname === menuUrl;
  const email = useUserStore((state) => state.email);

  const handleBubbleElClick = ({
    url,
    title,
  }: {
    url: string;
    title: string;
  }) => {
    if (title === 'Character') {
      // send GA event : CLICK_GENERATE_CHARACTER
      GAEvent(email, GA.ACTION.CLICK_GENERATE_CHARACTER, {
        button_type: 'gnb',
      });
    }
    navigate(url);
  };

  return (
    <>
      {isOpen && (
        <S.Bubble isOpen={isOpen}>
          <div>
            {navigationArr.slice(2, 4).map((menu, idx) => (
              <S.MenuWrapper
                key={`ChatNavigation_${idx}`}
                onClick={() =>
                  handleBubbleElClick({ url: menu.url, title: menu.title })
                }
                className={isActive(menu.url) ? 'active' : ''}
              >
                <Menu menu={menu} isActive={isActive(menu.url)} />
              </S.MenuWrapper>
            ))}
          </div>
        </S.Bubble>
      )}
    </>
  );
}
